import { render, staticRenderFns } from "./SaleLayoutEditElectronProperties.vue?vue&type=template&id=1101dd5d"
import script from "./SaleLayoutEditElectronProperties.vue?vue&type=script&lang=ts"
export * from "./SaleLayoutEditElectronProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1101dd5d')) {
      api.createRecord('1101dd5d', component.options)
    } else {
      api.reload('1101dd5d', component.options)
    }
    module.hot.accept("./SaleLayoutEditElectronProperties.vue?vue&type=template&id=1101dd5d", function () {
      api.rerender('1101dd5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleLayoutEditElectronProperties.vue"
export default component.exports